import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { Fragment } from "react";
import { Arc, Circle } from "react-konva";
import { ClockPoint } from "./ClockPoint";
var ACTIVE_COLOR = "#DD4E4E";
var INACTIVE_COLOR = "#f5caca";
export function HeatRange(_ref) {
  var nowAngle = _ref.nowAngle,
      range = _ref.range,
      clockRadius = _ref.clockRadius;

  var _range = _slicedToArray(range, 2),
      from = _range[0],
      to = _range[1];

  var hideHandles = from === 0 && to === 360;
  var isAffected = typeof nowAngle !== "undefined" && nowAngle > from;
  var inPast = typeof nowAngle !== "undefined" && nowAngle >= to;
  var transparentPart = isAffected && {
    from: from,
    to: inPast ? to : nowAngle
  };
  var opaquePart = !inPast && {
    from: isAffected ? nowAngle : from,
    to: to
  };
  return /*#__PURE__*/React.createElement(Fragment, null, transparentPart && /*#__PURE__*/React.createElement(Arc, {
    stroke: INACTIVE_COLOR,
    strokeWidth: 10,
    innerRadius: clockRadius,
    outerRadius: clockRadius,
    angle: transparentPart.to - transparentPart.from,
    rotation: transparentPart.from
  }), opaquePart && /*#__PURE__*/React.createElement(Arc, {
    stroke: ACTIVE_COLOR,
    strokeWidth: 10,
    innerRadius: clockRadius,
    outerRadius: clockRadius,
    angle: opaquePart.to - opaquePart.from,
    rotation: opaquePart.from
  }), !hideHandles && /*#__PURE__*/React.createElement(ClockPoint, {
    as: Circle,
    angle: from,
    clockRadius: clockRadius,
    radius: 7,
    fill: isAffected ? INACTIVE_COLOR : ACTIVE_COLOR
  }), !hideHandles && /*#__PURE__*/React.createElement(ClockPoint, {
    as: Circle,
    angle: to,
    clockRadius: clockRadius,
    radius: 7,
    fill: inPast ? INACTIVE_COLOR : ACTIVE_COLOR
  }));
}
;